<template>
<!-- template for the modal component -->
<transition name="modal">
  <div class="modal-mask" background-color="background">
    <div class="modal-wrapper" style="height:100vh;">
      <v-card max-width="600" style="margin:auto" class="pa-4" color="bmbackground">
        <div style="clear:both"></div>
        <div class="title mb-3" style="text-align: center">Confirm Call Attendant</div>
        <div class="subtitle-1" style="text-align: center">
          Tap 'Call Attendant' to have a field service technician come over and help you.
        </div>
        <br />
        <div>
          <v-btn v-if="!loadCircle" color="success" width="100%" @click="callAttendantConfirm()">Call Attendant</v-btn>
          <v-progress-circular style="margin: 0% 45%" indeterminate v-if="loadCircle" color="black" />
          <br />
          <v-btn class="mt-4" @click="$emit('close')" width="100%" color="error">Close</v-btn>
        </div>
      </v-card>
    </div>
  </div>
</transition>

<!-- app -->
</template>

<script>

export default {
  name: 'AttendantCalledModal',
  data() {
    return {
      loadCircle: false,
    }
  },
  props: {
    closeAttendantModal: Function,
  },
  methods: {
    callAttendantConfirm() {
      if (window.onewatch) {
        window.onewatch.callAttendant()
      }
      this.loadCircle = true
      setTimeout(() => {
        this.loadCircle = false
        this.closeAttendantModal()
      }, 2000)
    }
  }
}
</script>

<style>
.processTicketButton {
  border-radius: 8px;
  background-color: #4caf50;
  width: 100%;
  padding: 12px;
  color: #fff;
  font-size: 1.8em;
  text-align: center;
  bottom: -50px;
  z-index: 200;
  position: relative;
  font-weight: 600;
  cursor: pointer;
}

.addMultiButton {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  font-size: 1.1em;
  color: #333;
  width: 100%;
  padding: 10px;
  margin-top: 50px;
  text-align: center;
}

.unitStake {
  border: 1px solid #666;
  width: 100%;
  padding: 5px;
  font-size: 1.2em;
  font-weight: 500;
  background: #e6faff;
  color: #666;
  height: 1.8em;
  margin-top: 50px;
}

.betPriceButton {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  height: 3em;
  width: 17%;
  font-size: 1em;
  padding: 5px;
  text-align: center;
  margin: 7px 0 0 7px;
  line-height: 2.5em;
  font-weight: 600;
  color: #333;
  cursor: pointer;
}

.removeBorder {
  box-shadow: none;
  background-color: #ffffff;
  height: 3em;
  width: 18%;
  padding: 5px;
  text-align: center;
  margin: 5px 0 0 5px;
}

.modal-icon {
  margin-top: -80px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 350px;
  margin: 0px auto;
  padding: 20px 30px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.betPriceButtonClear {
  background-color: #ffffff;
  height: 3em;
  width: 17%;
  font-size: 0.9em;
  padding: 5px;
  text-align: center;
  margin: 7px 0 0 7px;
  line-height: 2.5em;
  font-weight: 600;
  color: #333;
}

@media only screen and (max-width: 600px) {
  .modal-container {
    width: 90%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .betPriceButton {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    height: 3em;
    width: 17%;
    font-size: 0.8em;
    padding: 5px;
    text-align: center;
    margin: 7px 0 0 7px;
    line-height: 2.5em;
    font-weight: 600;
    color: #333;
  }

  .betPriceButtonClear {
    background-color: #ffffff;
    height: 3em;
    width: 17%;
    font-size: 0.7em;
    padding: 5px;
    text-align: center;
    margin: 7px 0 0 7px;
    line-height: 2.5em;
    font-weight: 600;
    color: #333;
  }

  .modal-default-button {
    display: inline-block;
  }

  .raceTypeIconSlip {
    height: 80px;
    width: 80px;
    border-radius: 80px;
    background: #fff;
    margin: 0 auto;
    top: -80px;
    z-index: 200;
    position: relative;
    border: 6px solid #000;
    text-align: center;
  }
}

.raceTypeIconSlip {
  height: 80px;
  width: 80px;
  border-radius: 80px;
  background: #fff;
  margin: 0 auto;
  top: -60px;
  z-index: 200;
  position: relative;
  border: 6px solid #000;
  text-align: center;
}

.modal-default-button {
  float: left;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
